export interface GlobalConfig {
	SiteUrl: string | undefined;
	HomePageLocation: string | undefined;
	ContactUsLocation: string | undefined;
	PayBillLocation: string | undefined;
	SaveWaterLocation: string | undefined;
	TellUsYouAreMovingLocation: string | undefined;
	TroublePayingBillLocation: string | undefined;
	TroubleFindingMeterLocation: string | undefined;
	FindPostCode: string | undefined;
	PrivacyLink: string | undefined;
	ChangeOfAddress: string | undefined;
	SelfServeApiAddress: string | undefined;
	DirectDebitLocation: string | undefined;
	StrugglingToPay: string | undefined;
	PayingYourBill: string | undefined;
	SouthernWaterLogo: string | undefined;
	SouthernWaterLogoWidth: string | undefined;
	SouthernWaterLogoHeight: string | undefined;
	SouthernWaterLogoDetails?: {
		src: string,
		altText: string | undefined,
    srcset: string,
    sizes: string,
    width: number,
    height: number,
	} | undefined;
	SaveMoneyBySavingWater: string | undefined;
	WaterUsageGuide: string | undefined;
	ExtraHelpAndSupport: string | undefined;
	LiveChat: string | undefined;
	AlertOverrides?: ReadonlyArray<{ UrlMatch: string, Alert: { Id: string, Colour: string, Content: string, Icon?: string, IconHtml?: string, }, }>;
	CustomContent?: unknown | undefined;
}

export type ConfigValueAccessor = <K extends keyof GlobalConfig>(configKey: K) => GlobalConfig[K];

export function loadGlobalConfig(configValueAccessor: ConfigValueAccessor) : GlobalConfig {
	return {
		ChangeOfAddress: configValueAccessor('ChangeOfAddress'),
		ContactUsLocation: configValueAccessor('ContactUsLocation'),
		DirectDebitLocation: configValueAccessor('DirectDebitLocation'),
		FindPostCode: configValueAccessor('FindPostCode'),
		HomePageLocation: configValueAccessor('HomePageLocation'),
		LiveChat: configValueAccessor('LiveChat'),
		PayBillLocation: configValueAccessor('PayBillLocation'),
		PayingYourBill: configValueAccessor('PayingYourBill'),
		PrivacyLink: configValueAccessor('PrivacyLink'),
		SaveMoneyBySavingWater: configValueAccessor('SaveMoneyBySavingWater'),
		SaveWaterLocation: configValueAccessor('SaveWaterLocation'),
		SelfServeApiAddress: configValueAccessor('SelfServeApiAddress'),
		SiteUrl: configValueAccessor('SiteUrl'),
		SouthernWaterLogo: configValueAccessor('SouthernWaterLogo'),
		SouthernWaterLogoHeight: configValueAccessor('SouthernWaterLogoHeight'),
		SouthernWaterLogoWidth: configValueAccessor('SouthernWaterLogoWidth'),
		SouthernWaterLogoDetails: configValueAccessor('SouthernWaterLogoDetails'),
		StrugglingToPay: configValueAccessor('StrugglingToPay'),
		TellUsYouAreMovingLocation: configValueAccessor('TellUsYouAreMovingLocation'),
		TroubleFindingMeterLocation: configValueAccessor('TroubleFindingMeterLocation'),
		TroublePayingBillLocation: configValueAccessor('TroublePayingBillLocation'),
		WaterUsageGuide: configValueAccessor('WaterUsageGuide'),
		ExtraHelpAndSupport: configValueAccessor('ExtraHelpAndSupport'),
	};
}
